import { Injectable } from '@angular/core';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { PeremriFormaFjales, PeremrillojiParametri, PeremriNumri, PeremriRasa, PeremriVeta } from '@core/enums/peremri/peremri.enum';
import { PeremriConstants } from '@core/globals/peremri/peremri-constants';
import { PeremriForCreationDTO } from '@core/interfaces/dto/peremri-for-creation-dto.interface';
import { PeremriBaza } from '@core/interfaces/models/peremri-baza.interface';
import { PeremriVetorFormulaService } from './peremri-vetor-formula-service.service';

@Injectable({
  providedIn: 'root'
})
export class PeremriVetorService {

  constructor(
    private fb: UntypedFormBuilder,
    private peremeriVetorFormulaService: PeremriVetorFormulaService,
  ) { }

  insertForms(peremriBaza: PeremriBaza, form: UntypedFormGroup, manual: boolean) {
    const formArray = form.get('peremriBaza.peremriVetor') as UntypedFormArray;

    this.generateVetoreForms(formArray, manual);
    peremriBaza.peremri?.forEach((item) => {
      let index = formArray.controls.findIndex(
        (c) =>
          c.get('numriId')?.value == item.numriId &&
          c.get('vetaId')?.value == item.vetaId &&
          c.get('rasaId')?.value == item.rasaId &&
          c.get('pershkrimi')?.value == '' &&
          c.get('trajtaEShkurter')?.value == '' &&
          c.get('radhitja')?.value == item.radhitja &&
          c.get('formaFjalesId')?.value == item.formaFjalesId
      );
      if (index != -1) {
        formArray.controls[index].get('pershkrimi')?.setValue(item.pershkrimi);
        formArray.controls[index].get('trajtaEShkurter')?.setValue(item.trajtaEShkurter);
      } else {
        this.addNewLakimi(form, item.numriId, item.vetaId, item.rasaId, item.pershkrimi, item.trajtaEShkurter, item.formaFjalesId, item.radhitja);
      }
    });
  }

  generateForms(form: UntypedFormGroup, manual: boolean) {
    this.generateVetoreForms(form.get('peremriBaza.peremriVetor') as UntypedFormArray, manual);
  }

  generateFormula(peremriLlojiParametri: PeremrillojiParametri, form: UntypedFormGroup) {
    let formArray = form.get('peremriBaza.peremriVetor') as UntypedFormArray;
    this.peremeriVetorFormulaService.generateFormula(peremriLlojiParametri, formArray);
  }

  generateVetoreForms(formArray: UntypedFormArray, manual: boolean) {

    while (formArray.length > 0) {
      formArray.removeAt(0);
    }

    for (const pn of PeremriConstants.PeremriNumri) {
      for (const pv of PeremriConstants.PeremriVeta) {
        for (const pr of PeremriConstants.PeremriRasa) {
          const peremriForm = this.fb.group({
            numriId: pn.id,
            vetaId: pv.id,
            rasaId: pr.id,
            pershkrimi: '',
            trajtaEShkurter: '',
            radhitja: 1,
            formaFjalesId: null,
          });

          formArray.push(peremriForm);
        }
      }
    }

    if (!manual) formArray.disable();
  }

  addNewLakimi(form: UntypedFormGroup, numri: PeremriNumri, veta: PeremriVeta, rasa: PeremriRasa, pershkrimi?: string, trajtaEShkurter?: string, formaFjales?: PeremriFormaFjales, radhitja?: number) {
    const formArray = <UntypedFormArray>form.get('peremriBaza.peremriVetor');
    const peremriForm = this.fb.group({
      numriId: numri,
      vetaId: veta,
      rasaId: rasa,
      pershkrimi: pershkrimi,
      trajtaEShkurter: trajtaEShkurter,
      formaFjalesId: formaFjales,
      radhitja: radhitja
    });
    formArray.push(peremriForm);
  }

  getCreationDTO(form: UntypedFormGroup) {
    const creationDTO: PeremriForCreationDTO[] = [];

    let formArray: UntypedFormArray;

    formArray = form.get('peremriBaza.peremriVetor') as UntypedFormArray;

    formArray.value.forEach((p: any) => {
      creationDTO.push({
        numriId: p.numriId,
        vetaId: p.vetaId,
        rasaId: p.rasaId,
        pershkrimi: p.pershkrimi,
        renditjaId: p.renditjaId,
        radhitja: p.radhitja,
        trajtaEShkurter: p.trajtaEShkurter,
        formaFjalesId: p.formaFjalesId,
      })
    })
    console.log(formArray);

    return creationDTO;
  }
}
